import { Flex, Icon, Spacing, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'

import { Stripe } from '../../../../../../../../../../../../assets/images'
import { EmberRoute } from '../../../../../../../../../../../../enums/emberRoute'
import { useEmberRouteUrl } from '../../../../../../../../../../../../hooks/routing/useEmberRouteUrl'
import * as Styled from './styles'

export const ActivateStripeCardPayment = (): ReactElement => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { url: cardPaymentsSettingsUrl } = useEmberRouteUrl(EmberRoute.SettingsCardPayments)

  const handleActivateClick = useCallback(() => {
    if (cardPaymentsSettingsUrl) {
      navigate(cardPaymentsSettingsUrl)
    }
  }, [cardPaymentsSettingsUrl, navigate])

  return (
    <Styled.ActivateStripeCardPaymentWrapper type="button" onClick={handleActivateClick}>
      <Flex alignItems="center" gap={Spacing.S16}>
        <Styled.StripeLogo>
          <Stripe height={60} viewBox="0 0 120 120" width={60} />
        </Styled.StripeLogo>
        <Flex flexDirection="column" gap={Spacing.S4}>
          <Text weight="bold">{t('external_invoices.payment_methods_modal.method.card_payment.enable.title')}</Text>
          <Text colorVariant="secondary" variant="bodySM">
            {t('external_invoices.payment_methods_modal.method.card_payment.enable.description')}
          </Text>
        </Flex>
      </Flex>
      <Icon icon="chevronRight" />
    </Styled.ActivateStripeCardPaymentWrapper>
  )
}
